import { render, staticRenderFns } from "./Materiales.vue?vue&type=template&id=342bb8c9"
import script from "./Materiales.vue?vue&type=script&lang=js"
export * from "./Materiales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports